import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, ReactNode, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceTypeEnum } from '../../../models';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const InvoiceTypeField: FC<{
  value: InvoiceTypeEnum[] | null;
  onChange: (value: InvoiceTypeEnum[] | null) => void;
  error?: ReactNode;
}> = ({ value, onChange, error }) => {
  const { t } = useTranslation('reservation');
  const { t: tc } = useTranslation();
  const [selected, setSelected] = useState<Array<InvoiceTypeEnum>>([]);
  const {
    HotelApi: {
      settings: {
        financial: {
          cashRegister: { getAll },
        },
      },
    },
  } = useContext(RootContext);

  const handleChange = (item: InvoiceTypeEnum | 'all') => {
    if (item === 'all') {
      setSelected(
        Object.values(InvoiceTypeEnum).length === selected.length
          ? []
          : Object.values(InvoiceTypeEnum)
      );
      onChange([]);
      return;
    }

    // Toggle individual cashier selection

    const newSelected = selected.includes(item)
      ? selected.filter(id => id !== item)
      : [...selected, item];
    setSelected(newSelected);
    onChange(newSelected.length === Object.values(InvoiceTypeEnum).length ? [] : newSelected);
  };

  const allSelected =
    Object.values(InvoiceTypeEnum).length > 0 &&
    Object.values(InvoiceTypeEnum).every(id => selected.includes(id));

  return (
    <Box
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink>Invoices</InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={allSelected}
                  indeterminate={selected.length > 0 && !allSelected}
                  onChange={() => handleChange('all')}
                  sx={{ mr: 1 }}
                />
              }
              label={t('list.filter.all')}
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {(Object.values(InvoiceTypeEnum) || [])?.map(item => (
              <FormControlLabel
                key={item}
                control={
                  <Checkbox
                    checked={selected.includes(item!)}
                    onChange={() => handleChange(item)}
                    sx={{ mr: 1 }}
                  />
                }
                label={tc(`invoice_type.${item}` as any)}
                sx={{ py: 0.5, pl: 1.5 }}
              />
            ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
